import { colors } from '../../tailwind.marketing.config';
var foregroundToBackgroundColorMap = {
    'bacon': 'bg-surface-bacon',
    'bone': 'bg-surface-white',
    'beige': 'bg-surface-beige',
    'dark-blue': 'bg-surface-blue-dark',
    'pink': 'bg-deco-pink',
    'primary': 'bg-action-surface-primary',
    'shoe': 'bg-surface-shoe',
    'squash': 'bg-action-surface-primary',
    'white': 'bg-surface-white',
};
var ProductName;
(function (ProductName) {
    ProductName["BEEF_BLUEBERRY"] = "Beef Blueberry";
    ProductName["BEEF_JERKY"] = "Beef Jerky";
    ProductName["BEEF_MASH"] = "Beef Mash";
    ProductName["CHICKEN_CRANBERRY"] = "Chicken Cranberry";
    ProductName["CHICKEN_CUISINE"] = "Chicken Cuisine";
    ProductName["CHICKEN_JERKY"] = "Chicken Jerky";
    ProductName["COOKOUT"] = "Turkey + Chicken Cookout";
    ProductName["FULL_SPECTRUM"] = "Full Spectrum";
    ProductName["GI_TARGETED"] = "GI Targeted";
    ProductName["LAMB_PILAF"] = "Lamb Pilaf";
    ProductName["PORK_POTLUCK"] = "Pork Potluck";
    ProductName["SWEET_POTATO"] = "Sweet Potato";
    ProductName["TURKEY_FARE"] = "Turkey Fare";
})(ProductName || (ProductName = {}));
export { colors, foregroundToBackgroundColorMap, ProductName, };
